// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"57635":"382d4e2392864f92","75043":"8af8f76c219df3ea"}[chunkId] + ".js";
};